var btn = Ladda.create($(".ladda-button")[0]);
$("form").submit(function () {
    if ($(this).valid())
        btn.start();
});

function PasswordModelBase() {
    var self = this;

    self.successMessage = ko.observable();
    self.errorMessage = ko.observable();
    self.isSuccess = ko.observable(false);
    self.hasErrors = ko.observable(false);

    self.hasMessages = ko.computed(function() {
        return self.isSuccess() || self.hasErrors();
    });

    self.resetMessages = function() {
        self.successMessage(null);
        self.errorMessage(null);
        self.isSuccess(false);
        self.hasErrors(false);
    };
}

function ForgotPasswod() {
    var self = this;

    PasswordModelBase.call(self);

    self.submitForgot = function (sender) {
        var form = $(sender);
        var url = form.attr("action"),
            obj = form.serialize();

        self.resetMessages();

        $.post(url, obj).done(function (result) {
            if (window.HasValidationErrors)
                return;

            if (result.Success) {
                self.successMessage("");
                self.isSuccess(true);
            } else {
                self.hasErrors(true);
                self.errorMessage(result.Message);
            }
        }).fail(function (result) {
            self.hasErrors = ko.observable(true);
            self.errorMessage("Unknown error has occured, please try again or contact support");
        }).always(function() {
            btn.stop();
        });
    };
}

function ResetPassword() {
    var self = this;

    PasswordModelBase.call(self);

    self.seconds = ko.observable();

    self.startRedirectTimer = function(secondsCount) {
        self.seconds(secondsCount);
        var intervalId = setInterval(function () {
            if (self.seconds() > 0) {
                self.seconds(self.seconds() - 1);
                return;
            }

            window.location.href = "/signin-light";
        }, 1000);
    };

    self.submitReset = function (sender) {
        var form = $(sender);
        var url = form.attr("action"),
            obj = form.serialize();

        self.resetMessages();

        $.post(url, obj).done(function (result) {
            if (window.HasValidationErrors)
                return;

            if (result.Success) {
                self.successMessage("");
                self.isSuccess(true);
                self.startRedirectTimer(5);
            } else {
                self.hasErrors(true);
                self.errorMessage("Unknown error has occured, please try again or contact support");
            }
        }).fail(function (result) {
            self.hasErrors = ko.observable(true);
            self.errorMessage("Unknown error has occured, please try again or contact support");
        }).always(function () {
            btn.stop();
        });
    };
}

$(document).ready(function () {
    var forgotSectionElement = document.getElementById("forgotSection");
    if (forgotSectionElement)
        ko.applyBindings(new ForgotPasswod(), forgotSectionElement);


    var resetSectionElement = document.getElementById("resetSection");
    if (resetSectionElement)
        ko.applyBindings(new ResetPassword(), resetSectionElement);
});